import API from '@config/api';

const getClients = () => API.get('/clients');

export {getClients};
